

























import Vue from 'vue';

const COLORS = ['teal', 'red', 'indigo', 'orange', 'blue', 'deep-purple', 'cyan', 'green'];

export default Vue.extend({
  name: 'HAvatar',
  props: {
    name: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 40,
    },
    noImageText: {
      type: String,
      default: '',
    },
    avatarColor: {
      type: String,
      default: null,
    },
  },
  computed: {
    initials(): string {
      const initials = this.name.replace(/[^a-zA-Z- ]/g, '').match(/\b\w/g);

      if (initials) {
        return initials.join('').trim().toUpperCase();
      }

      return this.name.charAt(0).toUpperCase();
    },
    color(): string {
      if (this.avatarColor) return this.avatarColor;

      return COLORS[Math.floor(Math.random() * COLORS.length)];
    },
  },
});
